module.exports = __webpack_public_path__ + "static/media/google.61a88b6e.svg";